// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1952":"acfc544b3537d135","4202":"ab554976e9545c71"}[chunkId] + ".css";
};